<template>
  <ErrorMessage
    type="error"
    :title="title"
    :description="description"
    :show-retry="showRetry"
    :retry-text="retryText"
    @retry="handleRetry"
  />
</template>

<script>
import ErrorMessage from './ErrorMessage.vue'

export default {
  name: 'NetworkError',
  components: {
    ErrorMessage
  },
  props: {
    title: {
      type: String,
      default: 'Connection Problem'
    },
    description: {
      type: String,
      default: 'Unable to connect to the server. Please check your internet connection and try again.'
    },
    showRetry: {
      type: Boolean,
      default: true
    },
    retryText: {
      type: String,
      default: 'Try Again'
    }
  },
  emits: ['retry'],
  methods: {
    handleRetry() {
      this.$emit('retry')
    }
  }
}
</script>